import axios from 'axios'
import urls from './urls'

const login = async function ({ email, password }) {
  try {
    let data = {
      email,
      password,
      fcm: null
    }
    const res = await axios.post(urls.auth, data)
    // console.log('TCL: login -> res', res)
    return res.data
  } catch (error) {
    // console.log('TCL: login -> catch -> error', error)
    return Promise.reject(error)
  }
}

const logout = async function () {
  try {
    const res = await axios.post(urls.logout)
    return res.data
  } catch (error) {
    // console.log('TCL: error', error)
    return Promise.reject(error)
  }
}

export {
  login,
  logout
}
